module.exports = __webpack_public_path__ + "img/Group-427320573.a6fb8397.gif";